import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from './http-abstract-service';
import { AuthDto } from '../../dto';

@Injectable({
	providedIn: 'root'
})
export class HttpAuthService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/auth');
	}

	signIn(username: string, password: string): Observable<AuthDto> {
		const payload: AuthDto = {
			username: username,
			password: password
		}
		return super.post(`/sign-in`, payload);
	}
	verifyOtp(username: string, otp: string): Observable<AuthDto> {
        const payload: AuthDto = {
            username: username,
            otp: otp
        }
        return super.post(`/otp`, payload);
    }
	refreshToken(): Observable<AuthDto> {
		return super.get(`/refresh`);
	}

}
